import {
  OnQuantityChangeInput,
  OnQuantityChangeOutput,
  OnQuotePriceCreationInput,
  OnQuotePriceCreationOutput,
  OnUnitPriceChangeInput,
  OnUnitPriceChangeOutput,
} from '../types';

/**
 * Pass through function for strategies that do not have side effects on quantity change
 */
export function noOpQuantityChange(
  _input: OnQuantityChangeInput,
): OnQuantityChangeOutput {
  return {
    status: 'no-op',
  };
}

/**
 * Pass through function for strategies that do not have side effects on unit price change
 */
export function noOpUnitPrice(
  _input: OnUnitPriceChangeInput,
): OnUnitPriceChangeOutput {
  return {
    status: 'no-op',
  };
}

/**
 * Pass through function for strategies that do not need to calculate new quote prices
 */
export function noOpQuotePriceCreation(
  _input: OnQuotePriceCreationInput,
): OnQuotePriceCreationOutput {
  return {
    status: 'no-op',
  };
}
